import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { DefaultExpenseSource } from '@shared/services/gql.service';

export interface ExpenseDefaultsState {
  items: ExpenseSourceItems[];
}
export interface ExpenseSourceItems extends DefaultExpenseSource {
  cat: string;
  primary: string;
  quaternary: string;
  secondary: string;
  tertiary: string;
}

export function createInitialState(): ExpenseDefaultsState {
  return {
    items: [],
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'integrations' })
export class ExpenseDefaultsStore extends Store<ExpenseDefaultsState> {
  constructor() {
    super(createInitialState());
  }
}
